import React from 'react';
import './Landing.css';
import Hero from '../Hero/Hero';
import Numbers from '../Numbers/Numbers';
import ContactBanner from '../ContactBanner/ContactBanner';
import HeroIntro from '../HeroIntro/HeroIntro';
import TabBlock from '../TabBlock/TabBlock';

const Landing: React.FC = () => {
    return (
        <div className="landing">
            {/* Hero image section (use /hero-1.jpg) */}
            {/* Replace title/subtitle with the ones you want for each hero */}
            <Hero /* video={'./section-1.mp4'} */
                img={'/imgs/HandshakeHeroSuccit.png'}
                title={'Built for Modern Businesses'}
                subtitle={'We create fully custom apparel, PPE, and promotional products designed around your exact needs. Backed by 6+ years of experience, we adapt fast and deliver exactly what your business requires.'}
            />
            {/* Tabbed content section similar to image 3 */}
            <HeroIntro title={'About SUCCIT'} subtitle={'For over 6 years, SUCCIT has been the trusted wholesale partner for companies and growing enterprises. We specialize in providing Clothing, Promotional products and Personal protective equipment. Our commitment to excellence has earned us the confidence of industry leaders across manufacturing, construction, healthcare, HORECA and technology sectors. We understand the unique demands of businesses and organisations of every size and deliver solutions that meet the highest standards.'} />

            <TabBlock sectionTitle='Our Professional Services' sectionDescription='Wholesale solutions designed for enterprise-level requirements. We deliver quality, reliability, and exceptional service.' />{/* 1st Left image right text and 2nd Left text right image */}
            {/* <Question /> */}

            <Numbers title={'SUCCIT in numbers:'} /* description={'Discover the numbers behind SUCCIT:'} */ />
            
            {/* <Service items={[
                { tier: 'BRONZE', yearsLabel: '3 χρόνια', priceLabel: '124€', logoImage: '/logo/BRONZE.png' },
                { tier: 'SILVER', yearsLabel: '5 χρόνια', priceLabel: '176.8€', logoImage: '/logo/SILVER.png' },
                { tier: 'GOLD', yearsLabel: 'Εως και 10 χρόνια (μέχρι την ανανέωση του σήματος σας)', priceLabel: '248€', logoImage: '/logo/GOLD.png' },
            ]} /> */}
            {/* <div className="container">
                <Comments />
            </div> */}
            
            <ContactBanner />
        </div>
    );
};

export default Landing;
